import { apmAsyncScope } from "./utils";

const log = apmAsyncScope.scope("filters");
const dropUnsampledLog = log.scope("dropUnsampled");

/*                                            */
const knownFields = ["transactions", "errors"] as const;

/*                               */
const isArray = <T>(v: unknown): v is T[] => Array.isArray(v);

/*                              */
const logFormatPayloadInfo = (p: Payload): string[] =>
  knownFields.map((f) => `${f}: ${p[f]?.length ?? 0}`);

/**
 *
 *
 *
 *
 *
 *
 */
export const dropUnsampled: FilterFn = (payload) => {
  const ttt = payload[knownFields[0]];
  dropUnsampledLog.info("before processing", logFormatPayloadInfo(payload));

  /*                                */
  if (!isArray<{ sampled?: boolean }>(ttt)) return payload;

  /*                                                  */
  if (dropUnsampledLog.isEnabled()) {
    ttt.forEach((t, i) => {
      dropUnsampledLog.debug("transaction", i, "json:", JSON.stringify(t));
    });
  }

  /*                              */
  payload.transactions = ttt.filter((t) => !!t.sampled);

  /*                                                            */
  if (knownFields.every((f) => isArray(payload[f]) && payload[f].length === 0))
    return (dropUnsampledLog.info("dropped empty payload"), false);

  dropUnsampledLog.info("after processing", logFormatPayloadInfo(payload));
  return payload;
};
